const Promotions = {
    startTime: "1767589983000",
    endTime: "1774958399000",
    price: {
        elite: "999",
        intro: "399",
        upgrade: "600"
    },
    cashback: {
        elite: "3"
    }
}

export default Promotions;

